import { Colors } from '../../consts/Colors';

export default class ControllButton extends Phaser.GameObjects.Container {
    constructor(scene, x, side) {
        super(scene, x, 950 * scene.game.data.scaleY, []);

        this.scene = scene;
        this.side = side;

        this.illu;
        this.func;

        if (side === 'up') {
            this.illu = 'arrowUp';
            this.func = () => {
                this.scene.turtleMoveUp();
            };
        } else if (side === 'down') {
            this.illu = 'arrowDown';
            this.func = () => {
                this.scene.turtleMoveDown();
            };
        }

        scene.add.existing(this);

        // Create a rounded button background
        const radius = 68 * this.scene.game.data.scaleY;
        this.buttonBg = this.scene.add.graphics();
        this.buttonBg.fillStyle(Colors.Elmt.White, 1);
        this.buttonBg.fillCircle(0, 0, radius);

        // Add the icon in the middle
        this.icon = this.scene.add.image(0, 0, this.illu).setOrigin(0.5).setScale(0.8);

        // Add both to the container
        this.add(this.buttonBg);
        this.add(this.icon);

        this.setSize(this.buttonBg.width, this.buttonBg.height);
    }

    setActive() {
        const radius = 68 * this.scene.game.data.scaleY;
        const circle = new Phaser.Geom.Circle(0, 0, radius);

        this.buttonBg.clear();
        this.buttonBg.fillStyle(Colors.Elmt.LightBlue, 1);
        this.buttonBg.fillCircle(0, 0, radius);

        this.buttonBg.setInteractive({
            hitArea: circle,
            hitAreaCallback: Phaser.Geom.Circle.Contains,
            useHandCursor: true,
        });

        this.buttonBg.on('pointerdown', () => {
            if (this.side === 'up') {
                this.scene.turtleMoveUp();
            } else if (this.side === 'down') {
                this.scene.turtleMoveDown();
            }
        });
    }
}
